module.exports = __webpack_public_path__ + "img/qr-land.fb7a6594.png";